import React from "react";
import { Div, Row, Col, Text, Anchor, Image, Button } from "atomize";
import ebike from "../../assets/images/eBike.png";
import footer_rigth from "../../assets/images/fotter-right.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <div style={{ position: "relative" }}>
      <Div d="flex" justify="flex-end">
        <Image
          src={footer_rigth}
          w="139px"
          alt=""
          style={{ position: "absolute", top: "-70px" }}
        />
      </Div>
      <Div bg="#FCB72B" style={{ position: "relative", zIndex: "1" }}>
        <Div className="container" p={{ y: "5rem" }}>
          <Row>
            <Col size={{ xs: 12, md: 6 }}>
              <Div p="1rem" textAlign={{ md: "left", xs: "center" }}>
                <Text tag="h1" textSize="display1" m={{ b: "1rem" }}>
                  <Link to="#">
                    <Div d="flex" align="center">
                      <Button
                        h="2.5rem"
                        w="2.5rem"
                        rounded="circle"
                        m={{ r: "1rem" }}
                        shadow="2"
                        hoverShadow="4"
                        textColor="#FFC44B"
                        bg="#fff"
                        textSize="26px"
                      >
                        B
                      </Button>
                      <Image src={ebike} alt="ebike" w="20" h="25px" />
                    </Div>
                  </Link>
                </Text>
                <Text
                  textAlign="left"
                  textColor="#FFFFFF"
                  textWeight="300"
                  tag="span"
                  m={{ b: "4rem" }}
                >
                  Trafalgar provides progressive, and affordable
                  <br />
                  healthcare, accessible on mobile and online
                  <br />
                  for everyone
                  <br />
                  <br />
                </Text>
                <Text textAlign="left" textColor="#FFFFFF" textWeight="300">
                  &copy;Bike {currentYear}. All rights reserved
                  <br />
                  <br />
                </Text>
              </Div>
            </Col>
            <Col size={{ xs: 6, md: 2 }} textAlign="flex-end">
              <Div>
                <Div p="1rem" textAlign="flex-end">
                  <Text
                    textColor="#fff"
                    tag="h1"
                    textSize="heading"
                    m={{ b: "1rem" }}
                  >
                    Company
                  </Text>
                  <Anchor
                    href="#"
                    textColor="#FFFFFF"
                    textWeight="300"
                    hoverTextColor="#fff"
                    m={{ r: "1rem" }}
                    cursor="pointer"
                  >
                    Product
                  </Anchor>
                  <br />
                  <br />
                  <Anchor
                    href="#"
                    textColor="#FFFFFF"
                    textWeight="300"
                    hoverTextColor="#fff"
                    m={{ r: "1rem" }}
                    cursor="pointer"
                  >
                    Bike Type
                  </Anchor>
                  <br />
                  <br />
                  <Anchor
                    href="#"
                    textColor="#FFFFFF"
                    textWeight="300"
                    hoverTextColor="#fff"
                    m={{ r: "1rem" }}
                    cursor="pointer"
                  >
                    About Us
                  </Anchor>
                  <br />
                  <br />
                  <Anchor
                    href="#"
                    textColor="#FFFFFF"
                    textWeight="300"
                    hoverTextColor="#fff"
                    m={{ r: "1rem" }}
                    cursor="pointer"
                  >
                    Contact
                  </Anchor>
                </Div>
              </Div>
            </Col>
            <Col size={{ xs: 6, md: 4 }}>
              <Div>
                <Div p="1rem">
                  <Text
                    textColor="#fff"
                    tag="h1"
                    textSize="heading"
                    m={{ b: "1rem" }}
                  >
                    Help
                  </Text>
                  <Anchor
                    href="#"
                    textColor="#FFFFFF"
                    textWeight="300"
                    hoverTextColor="#fff"
                    m={{ r: "1rem" }}
                    cursor="pointer"
                  >
                    Help center
                  </Anchor>
                  <br />
                  <br />
                  <Anchor
                    href="#"
                    textColor="#FFFFFF"
                    textWeight="300"
                    hoverTextColor="#fff"
                    m={{ r: "1rem" }}
                    cursor="pointer"
                  >
                    Contact Support
                  </Anchor>
                  <br />
                  <br />
                  <Anchor
                    href="#"
                    textColor="#FFFFFF"
                    textWeight="300"
                    hoverTextColor="#fff"
                    m={{ r: "1rem" }}
                    cursor="pointer"
                  >
                    Instructions
                  </Anchor>
                  <br />
                  <br />
                  <Anchor
                    href="#"
                    textColor="#FFFFFF"
                    textWeight="300"
                    hoverTextColor="#fff"
                    m={{ r: "1rem" }}
                    cursor="pointer"
                  >
                    How it Works
                  </Anchor>
                </Div>
              </Div>
            </Col>
          </Row>
        </Div>
      </Div>
    </div>
  );
};

export default Footer;
